module.exports = __webpack_public_path__ + "static/wa-d7f00521710c48c78e8ab3a4d573466f.svg";